<template>
    <div class="automation-wizard-field-numeric">
        <CompassFormItem v-bind="formItemProps" :error="field.currentError || ''">
            <CompassInput
                :modelValue="localValue"
                type="number"
                :min="min"
                :max="max"
                menuClass="automation-wizard-field-numeric"
                @input="handleInput"
                @blur="handleBlur"
            >
                <template #suffix>
                    <span
                        class="automation-wizard-field-numeric__suffix typographies-paragraph-medium-regular"
                    >
                        {{ suffixSymbol }}
                    </span>
                </template>
            </CompassInput>
        </CompassFormItem>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: corpMapState } = createNamespacedHelpers('corp');

export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        unit: {
            type: String,
            default: 'currency',
            validator: (value) => ['currency', 'percent'].includes(value),
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: undefined,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.modelValue || '',
        };
    },
    computed: {
        ...corpMapState(['numformat']),
        formItemProps() {
            return {
                ...this.field.props?.formItem,
                label: this.field.props?.formItem?.label || '',
                required: this.field.required || false,
                requiredLabel:
                    this.field.props?.formItem?.requiredLabel ||
                    this.$t.__('common.labels.required'),
            };
        },
        suffixSymbol() {
            switch (this.unit) {
                case 'currency':
                    return this.numformat?.currencysymbol || '€'
                case 'percent':
                    return '%';
                default:
                    return '';
            }
        },
    },
    watch: {
        modelValue(newValue) {
            this.localValue = newValue || '';
        },
    },
    methods: {
        handleInput(event) {
            const inputValue = event.target.value;
            this.localValue = inputValue;
            this.$emit('update:modelValue', String(inputValue));
        },
        handleBlur() {
            const num = Number(this.localValue);
            if (!isNaN(num) && this.localValue !== '') {
                const rounded = num.toFixed(2);
                this.localValue = rounded;
                this.$emit('update:modelValue', String(rounded));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-field-numeric {
    &__suffix {
        color: var(--colors-common-text-standard-placeholder);
    }
}
</style>
